import { loadingAction } from 'store/globalState/global';
import apiFetch from 'utils/apiFetch';
import { setBreadcrumb } from 'components/Navbar/modules';
import { random, colors, invertColor } from 'utils/colors';
import history from 'store/history';
import _ from 'lodash';
import { ROUTE_INITIATIVES, ROUTE_MAIN_PAGE } from 'constants/urls';
import * as ACTION_TYPE from './types';

export const getNarrativeNextStep = (narrativeId, actualStep) => {
  const params = {
    current_step: actualStep,
  };

  const endPoint = `narrative/${narrativeId}/actual_step`;

  return apiFetch('GET', { endPoint }, params);
};

export const resetAll = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.RESET_ALL });
};

export const goHome = () => (dispatch) => {
  dispatch({ type: ACTION_TYPE.RESET_ALL });
  history.push(ROUTE_INITIATIVES);
};

export const getSpecificStep = (idn, ids) => (dispatch, getState) => {
  const { app } = getState();
  const url = `narratives/${idn}/step/${ids}`;
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: url })
    .then((step) => {
      dispatch({ type: ACTION_TYPE.SET_SPECIFIC_STEP, payload: step });
    });
  apiFetch('GET', { endPoint: `narratives/${idn}` })
    .then((narrative) => {
      dispatch(loadingAction(false));
      const { id, name, specialType } = narrative;
      let { color } = narrative;

      if (typeof app.advanced_configuration !== 'undefined' && typeof app.advanced_configuration.random_colors !== 'undefined' && app.advanced_configuration.random_colors) {
        color = random();
      } else {
        const colorInfo = _.find(colors, (c) => {
          if (c.color.toLowerCase() === color.toLowerCase()) {
            return true;
          }

          return false;
        });
        if (colorInfo) {
          color = colorInfo;
        }
      }

      const context = {
        id,
        elementType: 'narrative',
        elementId: id,
        name,
        specialType,
        color,
      };
      dispatch({ type: ACTION_TYPE.SET_ACTUAL_CONTEXT, payload: context });

      const breadcrumb = [
        {
          color: '#ffffff',
          text: name,
        },
      ];

      dispatch(setBreadcrumb(breadcrumb.slice()));
    });
  dispatch(loadingAction(false));
};

// Context functions
export const getNarrative = (narrativeId, firstStep) => (dispatch, getState) => {
  const { app } = getState();

  if (firstStep) {
    dispatch({ type: ACTION_TYPE.SET_START_STEP_ID, payload: firstStep });
  }
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: `narratives/${narrativeId}` })
    .then((narrative) => {
      dispatch(loadingAction(false));
      const { id, name, specialType } = narrative;
      let { color } = narrative;

      if (typeof app.advanced_configuration !== 'undefined' && typeof app.advanced_configuration.random_colors !== 'undefined' && app.advanced_configuration.random_colors) {
        color = random();
      } else {
        const colorInfo = _.find(colors, (c) => {
          if (c.color.toLowerCase() === color.toLowerCase()) {
            return true;
          }

          return false;
        });
        if (colorInfo) {
          color = colorInfo;
        }
      }

      const context = {
        id,
        elementType: 'narrative',
        elementId: id,
        name,
        specialType,
        color,
      };
      dispatch({ type: ACTION_TYPE.SET_ACTUAL_CONTEXT, payload: context });

      const breadcrumb = [
        {
          color: '#ffffff',
          text: name,
        },
      ];

      dispatch(setBreadcrumb(breadcrumb.slice()));
    });
};

export const getObjective = objectiveId => (dispatch) => {
  apiFetch('GET', { endPoint: `objective/${objectiveId}` })
    .then((response) => {
      let color = _.find(colors, { color: response.color });

      if (!color) {
        color = {
          color: response.color,
          contrastColor: invertColor(response.color),
        };
      }

      const context = {
        id: response.id,
        elementType: 'objective',
        elementId: response.id,
        name: response.name,
        color,
      };

      dispatch({ type: ACTION_TYPE.SET_ACTUAL_CONTEXT, payload: context });
      history.push(ROUTE_MAIN_PAGE);

      const breadcrumb = [
        {
          color: '#ffffff',
          text: response.name,
        },
      ];

      dispatch(setBreadcrumb(breadcrumb.slice()));
    });
};

export const setStepAsViewed = (id, narrativeId) => {
  const params = {
    type: 'narrative',
    id: narrativeId,
    is_visualizated: 1,
  };
  return apiFetch('POST', { endPoint: `question/${id}/viewed` }, params);
};



// WEBPACK FOOTER //
// ./src/modules/steps/actions.js